import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import history from 'utils/history';

import { SheetFooter, SheetBody, Button } from 'twyne-new.ui'
import UserForm from 'modules/admin/views/user/components/UserForm'

import appStore from 'stores/app';
import { useUserStore } from "../store";

class Form extends React.Component {

  state = {
    gender: null,
    active: true,
    adminPainel: true,
    password: "",
    siteID: this.props.siteID || appStore.currentSiteID || null
  };

  componentWillMount() {
    const data = this.props.data;
    if (data) {
      this.setState(data);
    }
  }

  handleValidSubmit = (model) => {
    model.is_admin = true;
    this.props.handleSubmit(Object.assign(this.state, model));
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit} >
        <SheetBody>
          <UserForm useUserStore={useUserStore} data={this.state} />
        </SheetBody>
        <SheetFooter>
          <Button onClick={() => history.goBack()} variant='ghost'>Cancel</Button>
          <Button type="submit" color="accent">Save</Button>
        </SheetFooter>
      </Formsy>
    );
  }
}

Form.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any
};

export default Form;
